import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_error/500')({
  component: Page500,
});

function Page500() {
  return (
    <main className='flex flex-col flex-1 justify-center items-center px-6 max-w-xl text-center gap-10 mx-auto'>
      <h1 className='text-6xl font-bold'>500</h1>
      <h2 className='font-bold text-3xl'>Something went wrong on our end.</h2>
      <p>
        Please try again later or contact&nbsp;
        <a href='mailto:talentiq@dxc.com' className='text-primary hover:underline'>
          talentiq@dxc.com
        </a>
        &nbsp;if the problem persists.
      </p>
    </main>
  );
}
